var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176.6 141.73",
    width: "current",
    height: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".h{fill:url(#e);}.i{fill:url(#d);}.j{fill:url(#g);}.k{fill:url(#f);}.l{fill:none;}.m{fill:#121228;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 127.49,
    y1: 47.91,
    x2: 91.25,
    y2: 47.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f3712f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f05a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d65026"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 44.85,
    y1: 63.45,
    x2: 83.54,
    y2: 63.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e3192"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 83.51,
    y1: 34.38,
    x2: 122.2,
    y2: 34.38,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 68.39,
    y1: 74.62,
    x2: 122.2,
    y2: 74.62,
    xlinkHref: "#d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "l"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M30.8,108.8v2.66h-4.25v11.24h-3.14v-11.24h-4.23v-2.66h11.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M45.05,108.8v2.6h-7.44v3.02h6.71v2.6h-6.71v3.08h7.66v2.6h-10.8v-13.9h10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M56.17,111.42c-2.38,0-4.23,1.85-4.23,4.27s1.85,4.29,4.23,4.29c1.25,0,2.62-.64,3.61-1.63l1.85,2c-1.47,1.51-3.59,2.48-5.62,2.48-4.15,0-7.29-3.08-7.29-7.11s3.2-7.03,7.4-7.03c2,0,4.11,.89,5.48,2.3l-1.83,2.22c-.95-1.09-2.32-1.81-3.61-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M68.62,108.8v5.8h6.29v-5.8h3.14v13.9h-3.14v-5.48h-6.29v5.48h-3.14v-13.9h3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M87.91,111.34c-1.05,0-1.77,.38-1.77,1.13,0,2.56,7.4,1.13,7.38,6.13,0,2.72-2.36,4.19-5.44,4.19-2.28,0-4.57-.87-6.13-2.2l1.25-2.56c1.43,1.27,3.45,2.08,4.92,2.08,1.29,0,2.06-.48,2.06-1.33,0-2.62-7.4-1.09-7.4-6.01,0-2.52,2.16-4.11,5.38-4.11,1.95,0,3.89,.6,5.28,1.51l-1.21,2.6c-1.47-.87-3.22-1.43-4.33-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M106.81,120h-6.43l-1.09,2.7h-3.24l6.03-13.9h3.24l5.94,13.9h-3.35l-1.09-2.7Zm-1.01-2.52l-2.18-5.4-2.2,5.4h4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M120.35,120.1c1.87,0,3.1-1.21,3.1-3.22v-8.08h3.14v8.08c0,3.67-2.4,5.96-6.23,5.96s-6.31-2.28-6.31-5.96v-8.08h3.14v8.08c0,2,1.31,3.22,3.18,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M137.82,111.42c-2.38,0-4.23,1.85-4.23,4.27s1.85,4.29,4.23,4.29c1.25,0,2.62-.64,3.61-1.63l1.85,2c-1.47,1.51-3.59,2.48-5.62,2.48-4.15,0-7.29-3.08-7.29-7.11s3.2-7.03,7.4-7.03c2,0,4.11,.89,5.48,2.3l-1.83,2.22c-.95-1.09-2.32-1.81-3.61-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M157.71,108.8v2.6h-7.44v3.02h6.71v2.6h-6.71v3.08h7.66v2.6h-10.8v-13.9h10.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "122.2 54.72 107.08 63.45 83.51 49.71 83.51 32.38 122.2 54.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "83.54 49.72 83.51 49.71 83.51 32.38 68.46 41.07 68.42 41.04 44.85 54.72 44.85 72.06 68.39 58.47 68.39 85.78 83.51 94.51 83.51 49.74 83.54 49.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "107.08 18.87 122.2 27.55 83.51 49.89 83.51 32.38 107.08 18.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "122.2 54.72 122.2 72.18 83.51 94.51 68.39 85.79 122.2 54.72"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2815e0084cb16107f47344297829c326.svg";
export { ForwardRef as ReactComponent };